<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('menu_logout') }}</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded">
              <div class="card-body p-t-25 p-b-30">
                <button type="submit"
                        class="advicebutton text-white confirm"
                        @click="submitLogout">
                  {{ $t('menu_logout') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    methods: {
      ...mapActions([
        'userLogout',
      ]),
      submitLogout () {
        this.userLogout()
        this.$router.push({ name: 'login' })
      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/profile/Logout.vue